export default "__VITE_ASSET___uW3RA_1__"